import { RootState } from '../../../rootReducer';

export const selectToken = (state: RootState): string => state.auth.token;
